import { View } from 'foundations-components/components/View';
import ACNavigatorButton from 'academy-common-lib/components/navigation/contentNavigator/ACNavigatorButton';
import { getHumanizedDuration } from '../../utils/utils';
import { HR } from 'foundations-components/transitional/components/HR';
import { TRACK_RECOMMENDATIONS_URL_FRAGMENT } from '../../constants/Navigation';
import NavigatorExamButton from './NavigatorExamButton';
import { HasParentPlaylist, NextPlaylistContent } from '../../features/playlistContent';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getTrackRecommendationsUrl } from '../../utils/RoutingUtils';
import LessonNavigator from './LessonNavigator';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CourseNavigator = ({
  trackId,
  introVideo,
  lessons,
  exam,
  language,
  activeContentId,
  activeLessonId
}) => {
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "course-navigator",
    paddingBlockEnd: "1600",
    children: [introVideo && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ACNavigatorButton, {
        active: activeLessonId === 'intro',
        "data-test-id": "course-navigator-introduction",
        helpText: getHumanizedDuration(introVideo.duration),
        title: introVideo.name,
        to: `/tracks/${trackId}/intro`
      }), /*#__PURE__*/_jsx(HR, {
        margin: "0"
      })]
    }), lessons.map(lesson => /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(LessonNavigator, {
        active: activeLessonId === lesson.id.toString(),
        activeAssetId: activeContentId ? Number(activeContentId) : undefined,
        assets: lesson.assets,
        duration: lesson.duration,
        id: lesson.id,
        language: language,
        name: lesson.name,
        trackId: Number(trackId),
        useCases: lesson.useCases
      }), /*#__PURE__*/_jsx(HR, {
        margin: "0"
      })]
    })), exam && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(NavigatorExamButton, {
        active: activeLessonId === 'exam',
        duration: exam.duration,
        language: language,
        totalQuestions: exam.totalQuestions,
        trackId: trackId
      }), /*#__PURE__*/_jsx(HR, {
        margin: "0"
      })]
    }), /*#__PURE__*/_jsx(HasParentPlaylist, {
      fallback: /*#__PURE__*/_jsx(ACNavigatorButton, {
        active: activeLessonId === TRACK_RECOMMENDATIONS_URL_FRAGMENT,
        "data-test-id": "course-navigator-recommendations",
        helpText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.recommendations.navigation.subheading"
        }),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.recommendations.navigation.heading"
        }),
        to: getTrackRecommendationsUrl(trackId.toString())
      }),
      children: /*#__PURE__*/_jsx(NextPlaylistContent, {
        render: ({
          title,
          subtitle,
          url,
          urlFragments
        }) => /*#__PURE__*/_jsx(ACNavigatorButton, {
          active: urlFragments.includes(activeLessonId),
          "data-test-id": "course-navigator-next-playlist-content",
          helpText: subtitle,
          title: title,
          to: url
        }),
        trackId: trackId
      })
    }), /*#__PURE__*/_jsx(HR, {
      margin: "0"
    })]
  });
};
export default CourseNavigator;